import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconModule } from '@spartacus/storefront';
import { TalkMeComponent } from './talk-me.component';

@NgModule({
  imports: [IconModule, NgbTooltipModule, SdvorIconComponent],
  declarations: [TalkMeComponent],
  exports: [TalkMeComponent],
})
export class TalkMeComponentModule {}
